<div class="basket-costs-overview">
  <div class="d-flex flex-sm-column flex-xl-row justify-content-between header fw-bold border-bottom pb-2 mb-2">
    <div class="table-col">{{ 'DESCRIPTION' | translate }}</div>
    <div class="table-col text-end">{{ 'AMOUNT' | translate }}</div>
  </div>
  <div class="d-flex flex-sm-column flex-xl-row justify-content-between align-lg-items-center py-1">
    <div class="table-col">{{ 'BASKET_ARTICLES_SUM' | translate }}</div>
    <div class="table-col text-end">
      <span [innerHTML]="basketArticlesSum | number:'1.2-2' | currencyConvert : basketQuote?.currency"></span>
    </div>
  </div>
  @if (basketQuote?.invoice_discount) {
    <div class="d-flex flex-sm-column flex-xl-row justify-content-between align-lg-items-center py-1">
      <div class="table-col">{{ 'INVOICE_DISCOUNT' | translate }}</div>
      <div class="table-col text-end">
        -<span [innerHTML]="basketQuote?.invoice_discount | number:'1.2-2' | currencyConvert : basketQuote?.currency"></span>
      </div>
    </div>
  }
  @if (basketQuote?.payment_discount) {
    <div class="d-flex flex-sm-column flex-xl-row justify-content-between align-lg-items-center py-1">
      <div class="table-col">{{ 'PAYMENT_DISCOUNT' | translate }}</div>
      <div class="table-col text-end">
        -<span [innerHTML]="basketQuote?.payment_discount | number:'1.2-2' | currencyConvert : basketQuote?.currency"></span>
      </div>
    </div>
  }
  @if (basketQuote?.shipment_costs) {
    <div class="d-flex flex-sm-column flex-xl-row justify-content-between align-lg-items-center py-1">
      <div class="table-col">{{ 'SHIPPING_COSTS' | translate }}</div>
      <div class="table-col text-end">
        +<span [innerHTML]="basketQuote?.shipment_costs | number:'1.2-2' | currencyConvert : basketQuote?.currency"></span>
      </div>
    </div>
  }
  @if (basketQuote?.surcharges_amount) {
    <div class="d-flex flex-sm-column flex-xl-row justify-content-between align-lg-items-center py-1">
      <div class="table-col">{{ 'SURCHARGES_AMOUNT' | translate }}</div>
      <div class="table-col text-end">
        +<span [innerHTML]="basketQuote?.surcharges_amount | number:'1.2-2' | currencyConvert : basketQuote?.currency"></span>
      </div>
    </div>
  }
  @if (basketQuote?.vat_amount) {
    <div class="d-flex flex-sm-column flex-xl-row justify-content-between align-lg-items-center py-1">
      <div class="table-col">{{ 'VAT_AMOUNT' | translate }}</div>
      <div class="table-col text-end">
        +<span [innerHTML]="basketQuote?.vat_amount | number:'1.2-2' | currencyConvert : basketQuote?.currency"></span>
      </div>
    </div>
  }
  @if (basketQuote?.vat_amount) {
    <div class="d-flex flex-sm-column flex-xl-row justify-content-between border-bottom border-dark">
      <div class="table-col"></div>
      <div class="table-col"></div>
    </div>
  }
  <div class="d-flex flex-sm-column flex-xl-row justify-content-between h5 fw-bold mt-3 gap-1">
    <div class="table-col">{{ 'PAYMENT_AMOUNT' | translate }}</div>
    <div class="table-col text-end bg-transparent">
      <span [innerHTML]="totalCalculation | number:'1.2-2' | currencyConvert : basketQuote?.currency"></span>
    </div>
  </div>
</div>